import { Link } from "react-router-dom";
import {
  ABOUT_US,
  ALL_RIGHT_RESERVED,
  CONTACT_US,
  HOME,
  RESOURCES,
  SERVICES,
  TRUST_TEXT,
} from "../../constants/translations";
import {
  ABOUT_US_ROUTE,
  CONTACT_US_ROUTE,
  HOME_ROUTE,
  RESOURCES_ROUTE,
  SERVICES_ROUTE,
} from "../../routes/routes";
import mainLogo from "../../asset/images/generals/main-logo.png";
import scrollToTop from "../functions/scrollToTop";

const FooterLink = ({ item }) => {
  return (
    <li className="footer-link-li">
      <Link to={item.link} className="footer-link" onClick={scrollToTop}>
        {item.text}
      </Link>
    </li>
  );
};

const Footer = () => {
  const firstColItems = [
    {
      id: 0,
      link: HOME_ROUTE,
      text: HOME,
    },
    {
      id: 1,
      link: ABOUT_US_ROUTE,
      text: ABOUT_US,
    },
    {
      id: 2,
      link: SERVICES_ROUTE,
      text: SERVICES,
    },
    {
      id: 3,
      link: RESOURCES_ROUTE,
      text: RESOURCES,
    },
  ];
  const secondColItems = [
    {
      id: 6,
      link: CONTACT_US_ROUTE,
      text: CONTACT_US,
    },
  ];
  return (
    <>
      <div className="footer-trust-wrapper">
        <p className="footer-trust-text">{TRUST_TEXT}</p>
      </div>
      <footer className="main-footer">
        <div className="content-wrapper mm-width">
          <Link to={HOME_ROUTE} onClick={scrollToTop} className="footer-logo">
            <img src={mainLogo} alt="Durrat Al Bahr" width={192} height={64} />
          </Link>
          <div className="footer-cols">
            <div className="footer-col">
              <ul className="footer-ul">
                {firstColItems.map((item) => (
                  <FooterLink item={item} key={item.id} />
                ))}
              </ul>
            </div>
            <div className="footer-col">
              <ul className="footer-ul">
                {secondColItems.map((item) => (
                  <FooterLink item={item} key={item.id} />
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="rights-reserved-wrapper mm-width">
          <p className="right-reserved">{ALL_RIGHT_RESERVED}</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
